@import 'styles/variables.scss';
@import 'styles/breakpoints.scss';

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: $navbar-height;
  padding: 16px 0;
  background-color: white;
  z-index: $z-index-navbar;
  text-align: center;
  box-shadow: 4px 6px 24px rgba(0, 0, 0, 0.05);
  @include breakpoint-up(md) {
    text-align: left;
  }
}

.navbarInner {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.logoLinkContainer {
  position: relative;
  width: 110px;
  // Leave enough room for the legal menu and login button on small screens.
  flex-shrink: 0;
  @include breakpoint-down(sm) {
    width: 84px;
    margin-right: 12px;
  }
  // Below the 320px design floor, let the mark give way so the controls remain visible.
  @media (max-width: #{$xs-floor - 1}) {
    flex-shrink: 1;
  }
}

.logo {
  max-height: 45px;
  width: 100%;
}

.navbarContent {
  height: 100%;
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  justify-content: flex-end;
  padding-right: 16%;
  @include breakpoint-up(md) {
    padding-right: 0;
  }
}

.hamburger {
  position: absolute;
  top: 25px;
  right: 25px;
  & span {
    width: 20px;
    background-color: $primary-color;
  }
}

.loginBtn {
  & span:last-child {
    white-space: nowrap;
  }
  @include breakpoint-down(sm) {
    padding-left: 12px;
    padding-right: 12px;
  }
}

.environment {
  position: absolute;
  right: 0;
  bottom: -2px;
  font-size: 0.7em;
  color: $secondary-color;
}

.desktopLegalLinks {
  display: none;
  align-items: center;
  gap: $spacer * 1.5;
  margin-right: $spacer * 1.5;

  a {
    white-space: nowrap;
  }

  @include breakpoint-up(md) {
    display: flex;
  }
}

.mobileLegalMenu {
  position: relative;
  margin-right: 10px;

  summary {
    cursor: pointer;
    list-style: none;
    white-space: nowrap;
    font-size: 0.8125rem;

    &::-webkit-details-marker {
      display: none;
    }

    &::after {
      content: '▾';
      margin-left: 4px;
    }
  }

  &[open] summary::after {
    content: '▴';
  }

  @include breakpoint-up(md) {
    display: none;
  }
}

.mobileLegalLinks {
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 210px;
  padding: 12px 16px;
  gap: 12px;
  background: white;
  border-radius: 4px;
  box-shadow: 4px 6px 24px rgba(0, 0, 0, 0.12);

  a {
    white-space: nowrap;
  }
}
